import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../App/store";
import "./Popup.scss";

export const Popup = () => {
  const [isHide, setIsHide] = useState<boolean>(true);
  const popupSelector = useSelector((state: RootState) => state.popup);

  useEffect(() => {
    if (!popupSelector.status) {
      setTimeout(() => {
        setIsHide(true);
      }, 500);
    } else setIsHide(false);
  }, [popupSelector.status]);

  return (
    <div className={`Popup ${popupSelector.status == 1 ? "Open" : "Close"}`}>
      <div className={`RenderContent ${isHide ? "Hide" : ""}`}>
        {popupSelector.renderContent}
      </div>
    </div>
  );
};
export default Popup;
